var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66406C5.40533 1.66406 1.66699 5.4024 1.66699 9.9974C1.66699 14.5924 5.40533 18.3307 10.0003 18.3307C14.5953 18.3307 18.3337 14.5924 18.3337 9.9974C18.3337 5.4024 14.5953 1.66406 10.0003 1.66406ZM10.0003 16.6641C6.32449 16.6641 3.33366 13.6732 3.33366 9.9974C3.33366 6.32156 6.32449 3.33073 10.0003 3.33073C13.6762 3.33073 16.667 6.32156 16.667 9.9974C16.667 13.6732 13.6762 16.6641 10.0003 16.6641Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33273 11.3257L6.4169 9.41323L5.24023 10.5932L8.3344 13.6807L13.9227 8.0924L12.7444 6.91406L8.33273 11.3257Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCheckCircle);
export default __webpack_public_path__ + "static/media/bx-check-circle.acb6d4ce6ccfa3dbaad913f1e31a8271.svg";
export { ForwardRef as ReactComponent };